export default __webpack_public_path__ + "static/media/alert-icon-4.009f8554.svg";